"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirestoreMyListManager = void 0;
var tslib_1 = require("tslib");
var constants_1 = require("../../../constants/constants");
var firestore_1 = require("firebase/firestore");
/**
 * Implementation of the MyListManagement interface for a FirestoreMyListManager.
 * @class
 * @implements {MyListManagement}
 */
var FirestoreMyListManager = /** @class */ (function () {
    function FirestoreMyListManager() {
        this.firestoreService = (0, firestore_1.getFirestore)();
    }
    FirestoreMyListManager.prototype.add = function (userId, item, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var favoritesCollectionRef;
            return tslib_1.__generator(this, function (_a) {
                favoritesCollectionRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.FAVORITES, item.id);
                return [2 /*return*/, (0, firestore_1.setDoc)(favoritesCollectionRef, item)];
            });
        });
    };
    FirestoreMyListManager.prototype.remove = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var favoritesDocRef;
            return tslib_1.__generator(this, function (_a) {
                favoritesDocRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.FAVORITES, itemId);
                return [2 /*return*/, (0, firestore_1.deleteDoc)(favoritesDocRef)];
            });
        });
    };
    FirestoreMyListManager.prototype.getItem = function (userId, itemId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var docRef, docSnap;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(userId && itemId && profileId && this.firestoreService)) return [3 /*break*/, 2];
                        docRef = (0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId, constants_1.COLLECTIONS.FAVORITES, itemId);
                        return [4 /*yield*/, (0, firestore_1.getDoc)(docRef)];
                    case 1:
                        docSnap = _a.sent();
                        return [2 /*return*/, docSnap.exists()];
                    case 2: return [2 /*return*/, false];
                }
            });
        });
    };
    FirestoreMyListManager.prototype.getItems = function (userId, profileId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var favoritesCollectionRef, favoritesSnapshot;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        favoritesCollectionRef = (0, firestore_1.collection)((0, firestore_1.doc)(this.firestoreService, constants_1.COLLECTIONS.ACCOUNTS, userId, constants_1.COLLECTIONS.PROFILES, profileId), constants_1.COLLECTIONS.FAVORITES);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(favoritesCollectionRef)];
                    case 1:
                        favoritesSnapshot = _a.sent();
                        return [2 /*return*/, favoritesSnapshot.docs.map(function (doc) { return doc.data(); })];
                }
            });
        });
    };
    return FirestoreMyListManager;
}());
exports.FirestoreMyListManager = FirestoreMyListManager;
